import { useEffect } from 'react';

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

const SITE_NAME = '看料社';

export default function Seo({ title, description, keywords, jsonLd }: SeoProps) {
  useEffect(() => {
    document.title = title;

    const ensure = (selector: string, create: () => HTMLElement): HTMLElement => {
      let el = document.head.querySelector(selector) as HTMLElement | null;
      if (!el) {
        el = create();
        document.head.appendChild(el);
      }
      return el;
    };

    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      const el = ensure(`meta[${attr}="${key}"]`, () => {
        const meta = document.createElement('meta');
        meta.setAttribute(attr, key);
        return meta;
      });
      el.setAttribute('content', content);
    };

    const url = window.location.href;

    setMeta('name', 'description', description);
    setMeta(
      'name',
      'keywords',
      keywords || '看料社,看料黑料,热点追踪,事件跟进,最新动态,进展时间线',
    );
    setMeta('name', 'robots', 'index,follow');
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:site_name', SITE_NAME);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);

    const link = ensure('link[rel="canonical"]', () => {
      const canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      return canonical;
    });
    link.setAttribute('href', url);
  }, [title, description, keywords]);

  const blocks: Record<string, unknown>[] = jsonLd
    ? Array.isArray(jsonLd)
      ? jsonLd
      : [jsonLd]
    : [];

  return (
    <>
      {blocks.map((block, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(block) }}
        />
      ))}
    </>
  );
}